import React from 'react';
import {ListGroup} from 'reactstrap';

import Manifest from './manifest-record';

const ResultList = ({manifests, showManifest}) => {
    return (
        <div>
            <ListGroup>
                {manifests.map((manifest, i) => 
                    <Manifest manifestKey={manifest.Id} key={manifest.Id} manifest={manifest} showManifest={showManifest} id={i} />
                )}
            </ListGroup>
        </div>
    );
};


export default ResultList;





// WEBPACK FOOTER //
// ./src/views/search/result-list.js